import { render } from "./TableVariants.vue?vue&type=template&id=9eff3816"
import script from "./TableVariants.vue?vue&type=script&lang=js"
export * from "./TableVariants.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__